import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex items-center gap-4 mt-4" }
const _hoisted_2 = {
  class: "block",
  href: "/Шаблон оптовое создание FTL заказов.xlsx",
  download: "Шаблон оптовое создание FTL заказов.xlsx"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-download" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_file_reader = _resolveComponent("file-reader")!
  const _component_the_button = _resolveComponent("the-button")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createBlock(_component_modal, {
    class: "auto",
    title: "Оптовое создание FTL заказа Excel",
    "confirm-button-text": "Создать заказ",
    loading: _ctx.state.is_loading,
    onCancel: _ctx.emitCancel,
    onConfirm: _ctx.createOrder
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_file_reader, {
          class: "flex-1",
          value: _ctx.state.file,
          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.file) = $event)),
          placeholder: "Выберите файл",
          accept: ".xlsx",
          disabled: _ctx.state.is_loading,
          "is-invalid": _ctx.state_form$.file.$error,
          "validation-errors": _ctx.state_form$.file.$errors
        }, null, 8, ["value", "disabled", "is-invalid", "validation-errors"]),
        _createElementVNode("a", _hoisted_2, [
          _createVNode(_component_the_button, {
            hint: "Скачать шаблон",
            class: "primary small"
          }, {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _: 1
  }, 8, ["loading", "onCancel", "onConfirm"]))
}